export default "__VITE_ASSET__DyJYRfYD__"